export class RouteName {
    static homePage: string = '/';
    static legalNotice: string = '/legal-notice';
    static privacyPolicy: string = '/privacy-policy';
}
